import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import { Button } from "../components/ui/button";
import { ArrowRight, Globe2 } from "lucide-react";
import { useI18n } from "../context/I18nContext";

const rise = {
  initial: { opacity: 0, y: 22 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.6, ease: "easeOut" },
};

const P = ({ children }) => (
  <p className="text-base sm:text-lg text-foreground/80 leading-[1.9]">{children}</p>
);

export default function Vision() {
  const { t } = useI18n();
  const paras = ["p1", "p2", "p3", "p4", "p5", "p6", "p7", "p8", "p9", "p10", "p11", "p12", "p13"];

  return (
    <div className="min-h-screen">
      <Navbar />

      <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-14 sm:pt-20 pb-24">
        {/* Heading above the box */}
        <motion.header {...rise} className="text-center">
          <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase font-bold text-primary bg-primary/10 rounded-full px-4 py-1.5">
            <Globe2 className="w-4 h-4" /> {t("landing.badge")}
          </span>
          <h1 className="mt-7 text-4xl sm:text-5xl lg:text-6xl font-heading font-black tracking-tighter leading-[1.05] text-primary">
            {t("vision.title")}
          </h1>
          <p className="mt-6 mx-auto max-w-2xl text-xl sm:text-2xl font-heading font-bold text-primary leading-[1.4]">
            {t("vision.lead")}
          </p>
        </motion.header>

        {/* Single manifesto container — warm dark brown */}
        <motion.div {...rise} className="mt-12 rounded-3xl bg-card border border-border shadow-sm p-8 sm:p-12 space-y-6 text-left">
          {paras.map((k) => (
            <P key={k}>{t(`vision.${k}`)}</P>
          ))}
        </motion.div>

        {/* CTA */}
        <motion.div {...rise} className="mt-10 text-center">
          <Link to="/register" data-testid="vision-start-journey">
            <Button size="lg" className="rounded-full text-base sm:text-lg px-9 h-14 font-bold group">
              {t("vision.cta")}
              <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
